import isArray from "lodash/isArray";
const sortJSON = (obj) => {
  if (typeof obj !== "object" || obj === null) {
    return obj;
  }
  if (isArray(obj)) {
    return obj.map(sortJSON);
  }
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};
  for (const key of sortedKeys) {
    sortedObj[key] = sortJSON(obj[key]);
  }
  return sortedObj;
};
export {
  sortJSON
};
